

<div style="padding: 10px">
<h3>01/07/22</h3>
<li> Fixed issue with schedule date being one day behind when editing jobs </li>
<li> Fixed issue with raterform not opening via locations page </li>
<li> Changed color of confirmation status background </li>
<li> Added full street address to locations page </li>
</div>